import { Link } from '@tanstack/react-router';

import { Badge } from '~shared/shadcn/ui/badge';

import {
  getRoomOverviewEventCards,
  hasRoomOverviewFieldValue,
  isPrivateLessonOverviewEvent,
} from './room-overview-mobile-cards.helpers';
import type { RoomOverviewMobileCardsProps } from './room-overview-mobile-cards.types';

export function RoomOverviewMobileCards({ rows }: RoomOverviewMobileCardsProps) {
  if (rows.length === 0) {
    return (
      <p className='py-8 text-center text-sm text-muted-foreground md:hidden'>
        No rooms to show.
      </p>
    );
  }

  return (
    <div className='space-y-3 md:hidden'>
      {rows.map((row) => {
        const eventCards = getRoomOverviewEventCards(row);

        return (
          <article
            key={row.roomId}
            className='rounded-xl border border-border/50 p-3.5'
          >
            <div className='mb-2 min-w-0'>
              <h3 className='break-words text-sm font-semibold leading-5 text-foreground'>
                {row.roomName}
              </h3>
              {hasRoomOverviewFieldValue(row.locationName) ? (
                <p className='mt-1 text-sm text-muted-foreground'>
                  {row.locationName}
                </p>
              ) : null}
            </div>

            {eventCards.length === 0 ? (
              <p className='text-sm text-muted-foreground'>No classes</p>
            ) : (
              <div className='space-y-3'>
                {eventCards.map(({ event, fields }) => {
                  const privateLesson = isPrivateLessonOverviewEvent(event);

                  return (
                    <div
                      key={`${event.classId}-${event.startMinutes}-${event.endMinutes}-${event.bookingId ?? ''}`}
                      className='rounded-lg border border-border/40 p-3'
                    >
                      <div className='mb-2 min-w-0'>
                        {privateLesson ? (
                          <Link
                            to='/classes/private-lessons'
                            className='break-words text-sm font-semibold text-foreground hover:underline'
                          >
                            {event.className}
                          </Link>
                        ) : (
                          <Link
                            to='/classes/$classId/enrolled-students'
                            params={{ classId: event.classId }}
                            className='break-words text-sm font-semibold text-foreground hover:underline'
                          >
                            {event.className}
                          </Link>
                        )}
                        {privateLesson ? (
                          <Badge variant='secondary' className='mt-1.5'>
                            Private lesson
                          </Badge>
                        ) : null}
                      </div>
                      <dl className='space-y-1.5'>
                        {fields.map((field) => (
                          <div
                            key={field.label}
                            className='flex items-start justify-between gap-3'
                          >
                            <dt className='w-[38%] shrink-0 text-sm leading-5 text-muted-foreground'>
                              {field.label}
                            </dt>
                            <dd className='min-w-0 flex-1 break-words text-right text-sm leading-5 text-foreground [overflow-wrap:anywhere]'>
                              {field.value}
                            </dd>
                          </div>
                        ))}
                      </dl>
                    </div>
                  );
                })}
              </div>
            )}
          </article>
        );
      })}
    </div>
  );
}
